/**
 * Amplify configuration for AWS Cognito authentication
 *
 * Values are sourced from runtimeConfig (fetched from /config.json at startup)
 * so the frontend build is environment-agnostic. For local development,
 * runtimeConfig falls back to .env.local values.
 */

import { getRuntimeConfig } from './runtimeConfig';

export function getAmplifyConfig() {
  const { userPoolId, userPoolClientId, apiEndpoint, apiRegion } = getRuntimeConfig();
  return {
    Auth: {
      Cognito: {
        userPoolId,
        userPoolClientId,
        loginWith: {
          email: true,
        },
        signUpVerificationMethod: 'code' as const,
        userAttributes: {
          email: {
            required: true,
          },
          given_name: {
            required: true,
          },
          family_name: {
            required: true,
          },
        },
        passwordFormat: {
          minLength: 8,
          requireLowercase: true,
          requireUppercase: true,
          requireNumbers: true,
          requireSpecialCharacters: false,
        },
        // Disable MFA and additional recovery prompts
        mfa: {
          status: 'off' as const,
          totpEnabled: false,
          smsEnabled: false,
        },
      },
    },
    API: {
      REST: {
        CloakNextAPI: {
          endpoint: apiEndpoint,
          region: apiRegion,
        },
      },
    },
  };
}
